var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-inner", attrs: { id: "tab-hawb" } },
    [
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _c(
            "div",
            [
              _c("cargo-ag-grid", {
                staticStyle: { height: "500px", width: "200px" },
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.billFinalRowData,
                  "auto-fit-content": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              }),
              _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "justify-content": "space-between",
                    "margin-top": "10px"
                  }
                },
                [
                  _c(
                    "el-button",
                    {
                      staticStyle: { "flex-grow": "1" },
                      attrs: {
                        no: "1",
                        type: "primary",
                        disabled: !_vm.isEdit
                      },
                      on: { click: _vm.addSubBill }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Add")))]
                  ),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "flex-grow": "1" },
                      attrs: { no: "2", type: "danger", disabled: !_vm.isEdit },
                      on: { click: _vm.removeSubBill }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Delete")))]
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("common-hawb", {
            ref: "hawb",
            attrs: {
              job: _vm.job,
              form: _vm.form,
              action: _vm.action,
              context: _vm.context,
              "view-source": "AeTabSubBill"
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }